const RECONCILIATION_UPLOAD_TYPES = {
  EMAIL: 'email',
  SFTP: 'sftp',
};

export default RECONCILIATION_UPLOAD_TYPES;
